import pluginId from './pluginId';

const getTrad = (id: string) => `${pluginId}.${id}`;

export default getTrad;
